<template>
	<div id="app">
		<AppHeader v-if="this.isAuthenticated" />
		<AppSide v-if="this.isAuthenticated" />
		<div class="main">
			<router-view :key="$route.fullPath"></router-view>
		</div>
		<AppFooter />
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader";
import AppSide from "@/components/AppSide";
import AppFooter from "@/components/AppFooter";

export default {
	name: "App",
	components: {
		AppHeader,
		AppSide,
		AppFooter
	},
	computed: {
		...mapGetters(["isAuthenticated"])
	}
};

</script>

<style lang="scss">	
	
	// @TODO Capire come mai è strettamente necessario mantere questo style anche se vuoto
	// L'importante è che ci sia anche solo un commento vuoto

	.main {
		padding-top: rem(40px);
		padding-left: rem(40px);
	}

</style>